<form id="form" [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="form">
	<div class="row">
		<div class="col">
			<label for="name" class="form-label theme-main-color fw-bold">Nom</label>
			<input
				autocomplete="off"
				required
				type="text"
				class="form-control"
				id="name"
				name="name"
				formControlName="name"
				[ngClass]="{
					'is-invalid': name.invalid && (name.dirty || name.touched),
					'is-valid': name.dirty && name.valid
				}"
			/>
			<div
				*ngIf="name.invalid && (name.dirty || name.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="name.errors?.required">Un nom est requis</span>
				<span *ngIf="name.errors?.maxlength"
					>Le nom ne doit pas dépasser {{ MAX_NAME_CHAR }} caractères</span
				>
				<span *ngIf="name.errors?.pattern"
					>Le nom doit être valide : pas de caractères spéciaux (accents
					autorisés)
				</span>
			</div>
		</div>
	</div>
	<div class="row my-4">
		<div class="col">
			<label for="inputAddresse" class="form-label theme-main-color fw-bold"
				>Adresse</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="inputAddresse"
				name="address"
				[typeahead]="addressList"
				[typeaheadAsync]="true"
				typeaheadOptionField="displayName"
				(typeaheadLoading)="changeTypeaheadLoading($event)"
				formControlName="address"
				(keyup)="selectedAddressKeyUp($event.target)"
				(typeaheadOnSelect)="onAddressSelect($event)"
				[ngClass]="{
					'is-invalid':
						address.invalid ||
						(address.dirty &&
							!(isAddressDefault.value || isAddressSelected.value)),
					'is-valid': address.dirty && address.valid && isAddressSelected.value
				}"
			/>
		</div>
	</div>

	<div class="row my-4">
		<label for="specialties" class="form-label theme-main-color fw-bold"
			>Spécialité(s)</label
		>
		<div class="row ps-4">
			<div
				class="col-md-4 form-check"
				*ngFor="let specialite of listSpecialite | orderBy : 'name' : 'asc'"
			>
				<div *ngIf="specialite.id !== 0">
					<input
						type="checkbox"
						name="{{ specialite.id }}"
						class="form-check-input"
						[value]="specialite"
						[checked]="isSpecialiteCheck(specialite)"
						[ngClass]="{
							'theme-main-color-check': isSpecialiteCheck(specialite)
						}"
						(change)="updateSelectedSpecialite($event, specialite)"
					/>
					<label class="form-check-label text-dark">
						{{ specialite.name }}
					</label>
				</div>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div class="col">
			<label for="inputNotes" class="form-label theme-main-color fw-bold"
				>Notes</label
			>
			<textarea
				class="form-control"
				id="inputNotes"
				formControlName="notes"
				[ngClass]="{
					'is-invalid': notes.invalid,
					'is-valid': notes.dirty && notes.valid
				}"
			></textarea>
			<div
				*ngIf="notes.invalid && (notes.dirty || notes.touched)"
				class="invalid-feedback"
			>
				<span *ngIf="notes.errors?.maxlength">Taille maximale atteinte</span>
			</div>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="
					!form.valid ||
					!(isAddressDefault.value || isAddressSelected.value) ||
					isValidateButtonClicked.value
				"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
